/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path d="M5.8 11.2595L2 21.9595L12.7 18.1695M4 2.95947H4.01M22 7.95947H22.01M15 1.95947H15.01M22 19.9595H22.01M22 1.95947L19.76 2.70947C19.1224 2.92186 18.5783 3.34911 18.2208 3.9182C17.8633 4.48728 17.7146 5.16286 17.8 5.82947C17.9 6.68947 17.23 7.45947 16.35 7.45947H15.97C15.11 7.45947 14.37 8.05947 14.21 8.89947L14 9.95947M22 12.9595L21.18 12.6295C20.32 12.2895 19.36 12.8295 19.2 13.7395C19.09 14.4395 18.48 14.9595 17.77 14.9595H17M11 1.95947L11.33 2.77947C11.67 3.63947 11.13 4.59947 10.22 4.75947C9.52 4.85947 9 5.47947 9 6.18947V6.95947M11 12.9595C12.93 14.8895 13.83 17.1295 13 17.9595C12.17 18.7895 9.93 17.8895 8 15.9595C6.07 14.0295 5.17 11.7895 6 10.9595C6.83 10.1295 9.07 11.0295 11 12.9595Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
